import { ActionButton, View } from "@adobe/react-spectrum";

interface ChannelHistoryFilterProps {
  activeFilter: "all" | "missed";
  onAll: () => void;
  onMissed: () => void;
}

const ChannelHistoryFilter = ({
  activeFilter,
  onAll,
  onMissed,
}: ChannelHistoryFilterProps) => {
  return (
    <View UNSAFE_className="call-history-header">
      <View UNSAFE_className="call-history-filter">
        <ActionButton
          UNSAFE_className={`call-history-button ${
            activeFilter === "all" ? "call-history-button-active" : ""
          }`}
          onPress={onAll}
          aria-label="all"
          data-testid="all-filter"
        >
          All
        </ActionButton>

        <ActionButton
          marginX={8}
          UNSAFE_className={`call-history-button ${
            activeFilter === "missed" ? "call-history-button-active" : ""
          }`}
          onPress={onMissed}
          aria-label="missed"
          data-testid="missed-filter"
        >
          Missed
        </ActionButton>

        <ActionButton
          UNSAFE_className="call-history-button"
          isDisabled
          aria-label="favourites"
          data-testid="favourites-filter"
        >
          Favourites
        </ActionButton>
      </View>
    </View>
  );
};

export default ChannelHistoryFilter;
